"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Heroheader() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223286" id="heroheader" className="relative flex min-h-[42vh] w-screen max-w-full lg:w-auto lg:max-w-6xl mx-auto items-center justify-center overflow-hidden bg-background bg-center bg-cover px-4 sm:px-6 py-12 text-foreground !bg-[url(https://prime-rhino.10web.cloud/wp-content/uploads/2026/05/sslogo.jpeg)] !bg-[url(https://prime-rhino.10web.cloud/wp-content/uploads/2026/05/sslogo.jpeg)]">
      {}
      <div className="absolute inset-0 z-0">
        
        
      </div>

      {}
      <div ref={ref} className={`relative z-20 container mx-auto px-6 text-center max-w-4xl transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
        
        
        
        
        <div className="mx-auto max-w-2xl space-y-6 text-lg leading-relaxed text-foreground/90 md:text-xl">
          
          
          
        </div>

        <div className="mt-12 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <Button asChild size="lg" className="h-14 rounded-md px-8 text-base tracking-wide bg-secondary text-secondary-foreground hover:opacity-90 shadow-md">
            
          </Button>
          <Button asChild variant="outline" size="lg" className="h-14 rounded-md px-8 text-base tracking-wide bg-transparent border-secondary/40 text-foreground hover:bg-secondary/10">
            
          </Button>
        </div>
      </div>
    </section>;
}